@if (identityModel.currentMember()?.memberId) {
    <div class="member" woa-activatable (onActivate)="showQrCode()">
        <div class="member-name">
            {{ identityModel.currentMember()?.contact?.firstName }} {{ identityModel.currentMember()?.contact?.lastName }}
        </div>
        @if (configurationModel.loginIdentityIsEmail()) {
            <div class="member-contact-details">
                @if (identityModel.currentMember()?.contact?.email) {
                    {{ identityModel.currentMember()?.contact?.email }}
                } @else if (identityModel.currentMember()?.contact?.mobilePhone) {
                    {{ identityModel.currentMember()?.contact?.mobilePhone }}
                }
            </div>
        }
        <div class="member-type">
            {{ identityModel.currentMember()?.membershipType.name }}
        </div>
        @if ((identityModel.currentMember()?.integratedLoyaltyId && !configurationModel.loginIdentityIsMemberNo()) || (identityModel.currentMember()?.memberNo && !identityModel.currentMember()?.integratedLoyaltyId)) {
            <div class="member-number">
                <div class="member-number-label">
                    {{ 'woa.common.memberNumber' | translate }}:
                </div>
                <div class="member-number-value">
                    {{ identityModel.currentMember()?.integratedLoyaltyId ?? identityModel.currentMember()?.memberNo }}
                </div>
            </div>
        }
        @if (identityModel.currentMember()?.integratedCardNo || (identityModel.currentMember()?.memberCardNo && !identityModel.currentMember()?.integratedLoyaltyId)) {
            <div class="member-number">
                <div class="member-number-label">
                    {{ 'woa.common.memberCardNumber' | translate }}:
                </div>
                <div class="member-number-value">
                    {{ identityModel.currentMember()?.integratedCardNo ?? identityModel.currentMember()?.memberCardNo }}
                </div>
            </div>
            <div class="member-code">
                <woa-qr-code-panel [value]="identityModel.currentMember()?.integratedCardNo ?? identityModel.currentMember()?.memberCardNo"
                                   [message]="'woa.label.member.qrCode' | translate"></woa-qr-code-panel>
            </div>
        }
        @if (configurationModel.app()?.supportsRedemption) {
            <div class="member-points">
                <div class="member-points-balance">
                    {{ identityModel.currentMember()?.pointsBalance }}
                </div>
                <div class="member-points-label">
                    {{ 'woa.label.member.points' | translate }}
                </div>
            </div>
        }
    </div>
}
